export default __webpack_public_path__ + "static/media/hairdresser.4def7ead.png";